import * as React from "react";

export class SuperBannerItem extends React.Component<{
    width?: number
    modifier?: string
    clientHashedClass?: string;
    clientHashedAttribute?: string;
}, {}>
{
    render() {
        let cls: string = "rj-superbanner__item" + (this.props.modifier ? ` ${this.props.modifier}` : "");
        cls += this.props.clientHashedClass ?  ` ${this.props.clientHashedClass}` : "";
        let dataUat: string = "superbanner-item" + (this.props.modifier ? `-${this.props.modifier}` : "");
        const styles = this.props.width ? { width: `${this.props.width}px` } : undefined;

        return (<div style={styles} className={cls} data-uat={dataUat} data-includein={this.props.clientHashedAttribute} >{this.props.children}</div>);
    }
}